import wasmPath from "WASM_PATH";

const mod = await __turbopack_wasm_module__(wasmPath, () => wasm_b1b6a44cda0ef428469235d0d537a6bf);

export default mod;
